import type { BariPreMdoInterimReportData } from '@common/validation/customControls/bariPre/bariPreMdoInterimReport/v1/bariPreMdoInterimReportSchemaV1';

export const initialData: BariPreMdoInterimReportData = {
    advies_aan_chirurg: null,
    advies_aan_huisarts: null,
    advies_aan_patient: null,
    datum_mdo: null,
    inclusie_in_zorgpad: null,
    klaar_voor_versturen: false,
    toelichting: null,
    verslag_bespreking_mdo: null,
    verwijsbrief_nodig: null,
};
